import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {CorporationsListComponent} from './corporations-list/corporations-list.component';
import {SettingsKeyLogDetailedViewComponent} from './settings-key-log-detailed-view/settings-key-log-detailed-view.component';
import {SettingsKeyLogComponent} from './settings-key-log.component';
import {SettingsKeyLogService} from '../../services/settings-key-log.service';
import {NotificationsModalComponent} from './notifications-modal/notifications-modal.component';
import {UtilsModule} from '../../modules/utils/utils.module';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        AngularMultiSelectModule,
        SafeHtmlPipeModule,
        UtilsModule
    ],
    declarations: [
        SettingsKeyLogDetailedViewComponent,
        SettingsKeyLogComponent,
        CorporationsListComponent,
        NotificationsModalComponent
    ],
    providers: [
        SettingsKeyLogService
    ]
})
export class SettingsKeyLogModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/settings-key-log/settings-key-log.module.ts